export const ERROR = {
  EMPTY_TOKEN: {
    message: 'Empty token'
  },
  EMPTY_RESPONSE: {
    message: 'Empty response'
  }
}
